module.exports = __webpack_public_path__ + "img/2.fb4f9508.png";